import { useT } from '@/lib/i18n/useT';

/**
 * Tiny copyright strip pinned to the bottom of the auth form column on
 * Login / Register. Kept as its own component so both pages stay aligned
 * and the brand string only needs to be updated in one place.
 *
 * The "Onxite" token is rendered as an external link to the marketing
 * site. Splitting the translation into prefix + suffix keeps the anchor
 * inside the localized sentence without touching translation tooling.
 */
export function AuthFooter() {
  const t = useT();
  const year = new Date().getFullYear();
  return (
    <p className="absolute inset-x-0 bottom-4 z-10 text-center text-[11px] tracking-wide text-[var(--color-fg-subtle)]">
      {t('auth.footer.copyrightPrefix', { year })}
      <a
        href="https://www.onxite.com"
        target="_blank"
        rel="noopener noreferrer"
        className="font-semibold text-[var(--color-fg-muted)] underline decoration-[var(--color-accent)] decoration-dotted underline-offset-2 transition-colors hover:text-[var(--color-accent)]"
      >
        Onxite
      </a>
      {t('auth.footer.copyrightSuffix')}
    </p>
  );
}
